import { Pipe, PipeTransform } from '@angular/core';
import { SortCriteria } from '@app/taskpane/settings/sort-setting/sort-setting.component';
import { WsFile } from '@model/ftf-api.model';
import { adjustTrifoldFilesWithCriteria } from '@utils/sorting-utils';

/**
 * Pipe for sorting trifold files based on specified criteria.
 */
@Pipe({ name: 'trifoldSort' })
export class TrifoldSortPipe implements PipeTransform {
  transform(files: WsFile[] | null | undefined, sortCriteria: SortCriteria[]): WsFile[] {
    if (!files || files.length === 0) return [];
    return adjustTrifoldFilesWithCriteria([...files], sortCriteria);
  }
}
